<template>
  <v-app class="member-layout">
    <!-- 상단 앱바 -->
    <v-app-bar color="white" elevation="1" height="56" class="member-app-bar">
      <MemberNavi
        v-model="drawer"
        :menu-items="filteredMenuItems"
        :current-user-name="currentUser?.name || ''"
        :biz-gubun-name="bizGubunName"
      />
      
      <v-toolbar-title class="app-title">
        <span class="title-text">CAION</span>
      </v-toolbar-title>
      
      <v-spacer />
      
      <!-- 기관 정보 -->
      <div class="member-info-area">
        <span class="org-name">{{ currentUser?.name }}</span>
        <span class="biz-gubun">{{ bizGubunName }}</span>
      </div>
      
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props" class="mr-2">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list density="compact">
          <v-list-item @click="goToMyInfo">
            <template v-slot:prepend>
              <v-icon size="small">mdi-information-outline</v-icon>
            </template>
            <v-list-item-title>내 정보</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="handleLogout">
            <template v-slot:prepend>
              <v-icon size="small">mdi-logout</v-icon>
            </template>
            <v-list-item-title>로그아웃</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- 메인 콘텐츠 -->
    <v-main class="member-main">
      <slot />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import MemberNavi from './MemberNavi.vue';
import { MEMBER_NAVIGATION_ITEMS, type NavItem } from '@/config/navigation';

const store = useStore();
const router = useRouter();

const drawer = ref(false);

const currentUser = computed(() => store.getters.currentUser);
const bizGubunName = computed(() => store.getters.bizGubunName);
/** 메뉴 minRole은 실제 운영자 권한 기준 (대리 로그인 시에도 admin 전용 메뉴 유지) */
const roleLevel = computed(() =>
  Number(store.getters.actualRoleLevel ?? store.getters.roleLevel ?? 0)
);

const filterMenuByRole = (items: NavItem[]): NavItem[] => {
  return items
    .filter((item) => {
      const minRole = item.minRole ?? 0;
      return roleLevel.value >= minRole;
    })
    .map((item) => {
      if (!item.children) return item;
      const children = filterMenuByRole(item.children);
      if (children.length === 0) return { ...item, children: [] };
      return { ...item, children };
    })
    .filter((item) => !item.children || item.children.length > 0 || !!item.to);
};

const filteredMenuItems = computed(() => filterMenuByRole(MEMBER_NAVIGATION_ITEMS));

const goToMyInfo = () => {
  router.push('/m/myinfo');
};

const handleLogout = () => {
  store.dispatch('logout');
  window.location.href = '/login';
};
</script>
